// removed by extract-text-webpack-plugin
module.exports = {"block":"_17dN-HTnO0Tm2_QLbAOxpM","heading":"Fyk7H1EeUPralzKiNQ3m_","lightGrey":"_3IWXI3evrdycM8xshJFJD4","yellow":"N6AdOpgOnM9zeX6DamIFK","blue":"_22OTTMnccf_ODhRcNLiQvs","items":"_3YdPZlPdBjQsNv6-FsxG6r","item":"_36_i32SO8Hxl-38kdJmoL7","link":"_1bsbQ1qzYA7FTpwy2cKm9Y","active":"_3CLIOX8txNbsbm9A-THWpH","linkText":"dkdDSIdVgBPk7bxMDTIx5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopicAreasNavigationBlock/TopicAreasNavigationBlock.module.scss
// module id = 812
// module chunks = 0